import _ from 'lodash';
import { useState, useRef, useEffect } from "react";
import { ContactCard } from "./contact-card";
import { arrayAny } from '../../utils/arrayUtils';


export const LandlordContactsTab = ({ contacts, saveCallBack }) => {
    const tabName = "Contacts";
    const ref = tabName.toLocaleLowerCase();

    const [newContact, setNewContact] = useState(null);
    const [rerender, setRerender] = useState(false);
    const [canSave, setCanSave] = useState(false);
    const [saveResult, setSaveResult] = useState(null);
    const [saving, setSaving] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    const childRefs = useRef([]); // Initialize an array of refs

    useEffect(() => {
        for (const child of _.filter(childRefs.current, c => !!c && c.canSave())) {
            if (saveResult && saveResult.success && child.canSave()) {
                child.setContact(child.getContact());
            }
        }
        if (saveResult && saveResult.success) {
            setCanSave(false);
            setSaveResult(null);
        }
        else {
            const contactsWithChanges = _.filter(childRefs.current, c => !!c && c.canSave()).length;
            setCanSave(contactsWithChanges > 0);
        }

    }, [rerender, saveResult, contacts, newContact]);

    const handleAddContact = () => {
        setNewContact({ name: '', email: '', phoneNumber: '', role: '', beingAdded: true });
    };

    const canAdd = () => {
        return !!!newContact && !saving;
    };

    const handleSave = () => {

        const children = _.filter(childRefs.current, c => !!c);
        const contactsToSave = _.filter(children.map(c => c.getContact()), c => c && !c.shouldDelete);

        if (!saving) {
            setCanSave(false);
            setSaving(true);

            saveCallBack(contactsToSave)
                .then(data => {
                    setNewContact(null);
                    setSaveResult(data.saveResult);
                })
                .catch(error => { console.error("An error occurred saving Contacts", error); })
                .finally(() => {
                    setRerender(!rerender);
                    setSaving(false);
                });
        }
    };

    const handleCancel = contact => {
        if (contact && contact.beingAdded) {
            setNewContact(null);
        }
    };

    const showButtons = () => {
        return newContact || (arrayAny(contacts));
    };

    return (contacts || newContact) && (
        <>
            <div key={ref} className="d-flex">
                <h3 className="mt-10px">{tabName}</h3>
                {showButtons() &&
                    <div className="mt-10px ms-auto btn-group">
                        <button className="btn btn-success btn-rounded px-4 rounded-pill btn-red" onClick={() => setShowDelete(!showDelete)}>
                            <i className="fas fa-fw fa-lg me-10px fa-trash-can ms-n2 "></i>Delete Contacts
                        </button>
                    </div>}
            </div>

            <div key={tabName} >
                <div className="row">
                    {newContact &&
                        <ContactCard
                            contact={newContact}
                            ref={ref => (childRefs.current[0] = ref)}
                            saveCallBack={c => handleSave(c)}
                            cancelCallBack={c => handleCancel(c)}
                            saving={saving}
                            saveResult={saveResult}
                            handleChange={() => setRerender(!rerender)}
                            showDelete={showDelete}
                        />
                    }
                    {contacts && _.sortBy(contacts, c => c.name)
                        .map((contact, i) =>
                            <ContactCard
                                key={`contact-card-${i + 1}`}
                                ref={ref => (childRefs.current[i + 1] = ref)}
                                contact={contact}
                                saveCallBack={c => handleSave(c)}
                                cancelCallBack={c => handleCancel(c)}
                                saving={saving}
                                saveResult={saveResult}
                                handleChange={() => setRerender(!rerender)}
                                showDelete={showDelete}
                            />
                        )}
                </div>
                <div className='mt-5px'>
                    {canAdd() && !saving &&
                        <button className="btn btn-primary" onClick={handleAddContact}>
                            <i title="Add Contact" className="fa fa-plus fa-lg"></i>&nbsp;&nbsp;Add
                        </button>
                    }
                    {canSave && !saving &&
                        <button title='Save' className="btn btn-primary ms-10px" onClick={handleSave}>
                            <i title='Save' className="fa fa-save"></i>&nbsp;&nbsp;Save
                        </button>}
                    {saving &&
                        <button disabled={true} className="btn btn-lime">
                            <i title="Saving..." className="fa fa-fw fa-arrows-rotate fa-pulse fa-lg"></i>
                        </button>
                    }
                    {saveResult && !saveResult.success && <div className="me-5px">{"Not saved. Try again later."}</div>}
                </div>
            </div>
        
        </>
    );
}